import { Stacked } from '@statsbomb/kitbag-components';
import { PhysicalMetricIndicator } from '../icons/PhysicalMetricIndicator';
import { MetricTooltip } from '../metricTooltip/MetricTooltip';

const TRAILING_BRACKET = /^(.*?)\s*(\([^()]*\))$/;

interface PhysicalMetricHeaderProps {
  metricKey: string;
  translationNs: string;
  label: string;
  testId: string;
}

export const PhysicalMetricHeader = ({ metricKey, translationNs, label, testId }: PhysicalMetricHeaderProps) => {
  const [, name = '', bracket] = label.match(TRAILING_BRACKET) ?? [];

  return (
    <Stacked gap="small">
      <MetricTooltip metricKey={metricKey} translationNs={translationNs}>
        <span data-testid={testId}>
          {bracket ? (
            <>
              {name}
              <br />
              {bracket}
            </>
          ) : (
            label
          )}
        </span>
      </MetricTooltip>
      <PhysicalMetricIndicator />
    </Stacked>
  );
};
